
import { Component, Vue, Prop } from "vue-property-decorator";
import { objAny } from "@/common/common-interface";
import { getProjectAdd } from "@/api/api-basic";
import regular from "@/common/regular";
import i18n from "@/config/i18n";
@Component({
  components: {}
})
export default class PiActivationCodeAdd extends Vue {
  @Prop({ default: "" }) private subSystemId!: string;
  private modalShow = false;
  private title = i18n.t("cardClient.add");
  private itemData: objAny = {};

  private formInline: objAny = {
    projectCode: "",
    projectName: ""
  };
  private formObj: objAny = {};
  private ruleInline: objAny = {
    projectName: [
      {
        required: true,
        message: i18n.t("cardClient.projectNamePl"),
        trigger: "blur"
      }
    ],
    projectCode: [
      {
        required: true,
        validator: regular.int,
        trigger: "blur"
      },
      {
        type: "string",
        min: 8,
        message: i18n.t("cardClient.projectCodeMax"),
        trigger: "blur"
      }
    ]
  };

  public open() {
    this.modalShow = true;
    this.formInline.projectName = "";
    this.formInline.projectCode = "";
  }

  public handleSubmit() {
    this.formObj.validate((valid: boolean) => {
      if (valid) {
        this.submitData();
      }
    });
  }
  async submitData(): Promise<void> {
    const ret = await getProjectAdd(this.formInline);
    if (ret.status === this.$config.apiStatus) {
      this.$Message.success(i18n.t("operationSucess"));
      this.$emit("success");
      this.modalShow = false;
    }
  }
  public handleReset() {
    this.formObj.resetFields();
  }

  mounted() {
    this.formObj = this.$refs["formValidate"];
  }
}
